import React from "react";
import queryString from "query-string";

export const variablesFromRouter = (ComposedComponent, defaultSort) => {
    return class extends React.Component {
        constructor() {
            super();
        }

        render() {
            let props = this.props;
            let limit = 20;
            let page = 1;
            let houseId = 0;
            let filters = [];
            let sort = defaultSort || "displayPrice";
            let regionId = 0;
            let tariffsType = [
                {
                    id: "internet",
                    checked: false,
                },
                {
                    id: "tv",
                    checked: false,
                },
                {
                    id: "mobile_new",
                    checked: false,
                },
            ];
            let exists = [];
            let filterAggregate = [];
            if (props.match.params.page) {
                page = props.match.params.page;
            }

            let params = queryString.parse(props.location.search);

            if (params.sort) {
                sort = params.sort;
            }

            if (params.exists) {
                if (params.exists === "exclusives") {
                    exists.push(params.exists);
                }
            }

            if (params.tariff) {
                let types = params.tariff.split(",");
                types.forEach(name => {
                    tariffsType.forEach(item => {
                        if (name == item.id) {
                            item.checked = true;
                        }
                    });
                });
                tariffsType = tariffsType.map(item => {
                    return item.checked ? item.id : `!${item.id}`;
                });
                exists.push(tariffsType.join(","));
            }

            if (params.providers) {
                filters.push(`provider.id=${params.providers}`);
            }

            if (params.rating) {
                filters.push(`rating_type=${params.rating}`);
            }

            if (params.service) {
                filters.push(`order_type_id=${params.service}`);
            }

            if (params.dody) {
                filters.push(`dody.global_id=${params.dody}`);
            }

            if (params.house_id) {
                houseId = Number(params.house_id);
            }

            if (params.speed) {
                let getParamsSpeed = params.speed.split(",");
                filters.push(`internet.speed_in>${getParamsSpeed[0] - 1}`);
                filters.push(
                    `internet.speed_in<${getParamsSpeed[1] * 1.0 + 1}`
                );
            }

            if (params.price) {
                let getParamsPrice = params.price.split(",");
                filters.push(`displayPrice>${getParamsPrice[0] - 1}`);
                filters.push(`displayPrice<${getParamsPrice[1] * 1.0 + 1}`);
            }
            if (props.match.params.regionUrl) {
                filters.push(`region.url=${props.match.params.regionUrl}`);
                filterAggregate.push(
                    `region.url=${props.match.params.regionUrl}`
                );
            }

            if (props.match.params.providerName) {
                filters.push(
                    `provider.url_name=${props.match.params.providerName}`
                );
                filterAggregate.push(
                    `provider.url_name=${props.match.params.providerName}`
                );
            }
            if (params.district) {
                filters.push(`districts.id=${params.district}`);
            }

            let filterRecommend = "&recommend=1";

            let streetId = parseInt(params.street_id);
            let badhouse = params.badhouse;
            let variables = {
                filter: filters.join("&"),
                filterAggregate: filterAggregate.join("&"),
                filterAggregate2: filterAggregate.join("&"),
                limit: limit,
                offset: limit * (page - 1),
                withAggregate: 1,
                houseId: houseId,
                streetId: streetId,
                badhouse: {
                    full: badhouse,
                },
                with_default: 1,
                filterExclusive: filters.join("&"),
                filterRecommend: filters.join("&") + filterRecommend,
                sort: sort,
                region_url: props.match.params.regionUrl,
                exists: exists.join(","),
                filters,
            };

            return <ComposedComponent {...this.props} variables={variables} />;
        }
    };
};
export const variablesFromProps = ComposedComponent => {
    return class extends React.Component {
        constructor() {
            super();
        }

        render() {
            let props = this.props;
            let {
                ApplicationModel: { filtersModel },
            } = this.props;
            let limit = 20;
            let page = this.props.ApplicationModel.filtersModel.paginatorPage;
            let filters = [];
            let filterAggregate = [];

            if (props.regionUrl) {
                filters.push(`region.url=${props.regionUrl}`);
                filterAggregate.push(`region.url=${props.regionUrl}`);
            }
            if (props.providerUrl) {
                filters.push(`provider.url_name=${props.providerUrl}`);
                filterAggregate.push(`provider.url_name=${props.providerUrl}`);
            }

            let variables = {
                filter: filters.join("&"),
                filterAggregate: filterAggregate.join("&"),
                limit: limit,
                offset: limit * (page - 1),
                withAggregate: 1,
            };
            return <ComposedComponent {...this.props} variables={variables} />;
        }
    };
};
